import api from 'src/config/api';
import {
	IGetPatientsRequestParams,
	INewPatientDetails,
	IPatientDetails,
	IPatientCreateEditFormData,
	IPatientBase,
} from 'src/features/patient/domain/types';

export const patientApi = {
	getPatients: async (
		requestParams: IGetPatientsRequestParams,
		siteSlug: string,
	): Promise<IPaginatedResponse<IPatientBase>> => {
		const {
			page = 1,
			search,
			sort,
			order,
			user_id,
			start_date,
			end_date,
			completion_status,
		} = requestParams;

		const params = new URLSearchParams({
			page: page.toString(),
			...(search && { search }),
			...(sort && order && { sort, order }),
			...(user_id && { user_id }),
			...(start_date && end_date && { start_date, end_date }),
			...(completion_status && { completion_status }),
		});

		const response = await api.get(`/api/v1/patients?${params}`, {
			headers: {
				Site: siteSlug,
			},
		});
		return response.data;
	},

	getPatientDetails: async (
		patientId: number,
		siteSlug: string,
	): Promise<IPatientDetails> => {
		const response = await api.get(`/api/v1/patient/${patientId}`, {
			headers: {
				Site: siteSlug,
			},
		});
		return response.data;
	},

	createPatient: async (
		siteSlug: string,
		requestBody: IPatientCreateEditFormData,
	): Promise<INewPatientDetails> => {
		const response = await api.post(`/api/v1/patient`, requestBody, {
			headers: {
				Site: siteSlug,
			},
		});
		return response.data;
	},

	updatePatient: async (
		siteSlug: string,
		patientId: number,
		requestBody: IPatientCreateEditFormData,
	): Promise<INewPatientDetails> => {
		const response = await api.patch(
			`/api/v1/patient/${patientId}`,
			requestBody,
			{
				headers: {
					Site: siteSlug,
				},
			},
		);
		return response.data;
	},

	deletePatient: async (
		siteSlug: string,
		patientId: number,
	): Promise<void> => {
		const response = await api.delete(`/api/v1/patient/${patientId}`, {
			headers: {
				Site: siteSlug,
			},
		});
		return response.data;
	},
};
